import m from 'mithril';
import '../roomselection/RoomSelectionPage.css'
import MessageProvider from '../../../MessageProvider';
import { Dialog, SvgIcon } from '../../../components/common/MaterialDesignComponents';
import { RoomType, MultiLangString, TemporaryRoomTypeSelection } from '../../../Models';
import { getValueByLang } from '../../../Utils';
import RoomTypeBookableOptionComponent from './RoomTypeBookableOptionComponent';

interface Attrs {
    roomTypeSelectedCount: number;
    messageProvider: MessageProvider;
    roomType: RoomType;
    onViewImagesSelected: (photos: string[]) => void;
}

export default function RoomDetailsComponent(): m.Component<Attrs> {
    let showingTerms = false;
    let showingDialog = false;
    return {
        view(vnode) {
            let {roomType, messageProvider, roomTypeSelectedCount, onViewImagesSelected } = vnode.attrs; 

            return m("div.mb-3", { class: "card shadow rounded-20" }, [
                        m("div", { class: "row no-gutters" }, [
                            m("div", { class: "col-4",
                                onclick: function (event) {
                                    console.log("Show more images.");
                                    event.preventDefault();
                                    onViewImagesSelected(roomType.photoUrls);
                                }
                            }, [
                                m("img", {
                                    src: (roomType.featuredPhotoUrl != null) ? roomType.featuredPhotoUrl : "https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
                                    class: "card-img thumb-img rounded-start",
                                    loading: "lazy"
                                }),
                                m("div", { class: "card-img-overlay" }, [
                                    m("button", {
                                        class: "btn btn-sm show-room-photos text-white"
                                    },
                                        m(SvgIcon, {
                                            iconType: "photo_size_select_actual"
                                        }), " " + ((roomType.photoUrls != null) ? roomType.photoUrls.length : 0) +
                                    ((roomType.photoUrls != null && roomType.photoUrls.length > 1) ? " " + messageProvider.get("photos") : " " + messageProvider.get("photo")))
                                ])
                            ]),
                            m("div", { class: "col-8" }, [
                                m("div.d-flex", [
                                    m("div.p-3", [
                                        m("div.pb-2", m("h5.room-name-color", getValueByLang(roomType.name, messageProvider.getCurrentLang()))),
                                        m("div.mb-1 d-flex",
                                            m("div.pr-2", m("i.bi bi-check-lg text-muted pr-1")),
                                            m("div.ml-auto", {class: "ellipsis-more-than-two-line ellipsis-color"}, [
                                                roomType.amenities.map((amenity, index) => {
                                                    let amenityStr: string = ""
                                                    if(index < roomType.amenities.length -1){
                                                        amenityStr += getValueByLang(amenity.label, messageProvider.getCurrentLang()) + 
                                                            ((messageProvider.getCurrentLang() == "en")?", ": "၊ ")
                                                    }else{
                                                        amenityStr += getValueByLang(amenity.label, messageProvider.getCurrentLang())
                                                    }
                                                    return m("span.text-sm-left.pr-1 text-muted", amenityStr)
                                                })
                                            ])
                                        ),
                                    ]),
                                    (roomTypeSelectedCount > 0)? 
                                    m("div.ml-auto triangle-down", m("div.show-room-selected-count p-2 text-white", roomTypeSelectedCount)):null
                                ])                                                            
                            ])
                        ]),
                        m("div", {}, 
                                m(RoomTypeBookableOptionComponent, {
                                    messageProvider: messageProvider,
                                    roomType: roomType,
                                    numberOfExtraBedsAllowed: roomType.numberOfExtraBedsAllowed
                                })
                        ),
                        getValueByLang(roomType.description, messageProvider.getCurrentLang()).length>10?
                        m("div", { class: "p-3 border-top radius-bottom bg-white clickable" ,
                                    onclick: function (event:Event) {
                                        showingTerms = !showingTerms;
                                    }
                                }, 
                        [
                            m("div.row", [
                                m("div", { class: "col-10" }, messageProvider.get("room_detail")),
                                m("div", { class: "col-2 text-right" },
                                    (showingTerms) ?
                                    m("i.bi bi-chevron-up") :
                                    m("i.bi bi-chevron-down")
                                )
                            ]),
                            (showingTerms) ?
                            m("div", { class: "mt-2" },
                                [
                                    (roomType.amenities.length > 0)?
                                    [
                                        m("small.text-muted font-weight-bold", messageProvider.get("room_amenity")),
                                        m("div.row mb-3 mt-2", [
                                            roomType.amenities.map(function(amenity){
                                                return  m("div.col-6 pb-2", [
                                                    m("div.d-flex bd-highlight", [
                                                        m("div.flex-shrink-1 pr-2 align-self-center", 
                                                            m("img", {
                                                                width: "18",
                                                                height: "18",
                                                                src: amenity.defaultIcon
                                                            })
                                                        ),
                                                        m("div.w-100",  m("span", getValueByLang(amenity.label, messageProvider.getCurrentLang())))
                                                    ])
                                                ])
                                            })
                                        ])
                                        
                                    ]:null,
                                    m(SectionComponent, {
                                        title:"Description", 
                                        content: roomType.description, 
                                        messageProvider: messageProvider
                                    })
                                ]                        
                            ): null 
                        ]):null,
                        m(Dialog, {
                            title: "Guaranteed Amenities",
                            isOpen: showingDialog,
                            onClose : () => {
                                showingDialog = false;
                            },
                            actionItems : [
                                {
                                    label: "Ok",
                                    onclick: () => {
                                        showingDialog = false;
                                    }
                                }
                            ]
                        }, roomType.amenities.map(function(amenity){
                            return  m("div", {class: "row mt-1"}, [
                                m("div", {class: "col-1 mr-2"}, [
                                    m("img", {src: amenity.defaultIcon})
                                ]),
                                m("div", {class: "col"}, [
                                    m("div", {}, getValueByLang(amenity.label, messageProvider.getCurrentLang()))
                                ])
                            ])
                        }
                        ))
                    ])
                        
        }
    }
}

function SectionComponent(): m.Component<{
    title:string, 
    content:MultiLangString,
    messageProvider: MessageProvider
}> {
    return {
        view(vnode) {
            const {title, content, messageProvider} = vnode.attrs;
            return [
                m("strong.text-muted", title),
                m("div", { class: "mb-3" }, 
                    m("small", getValueByLang(content, messageProvider.getCurrentLang()))
                )
            ]
        }
    }
}